import axios from "axios";
import { getToken } from "@/utils/authHelpers";
import { API_BASE_URL } from "@/utils/api";
import { ShipDataType } from "@/types/apiTypes";

export const fetchSingleShipApi = async (
  shipId: string,
): Promise<ShipDataType> => {
  const token = await getToken();
  if (!token) throw new Error("No authentication token found");

  const response = await axios.get<ShipDataType>(
    `${API_BASE_URL}/get-ship/${shipId}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};
